<template>
  <nav class="top-bar-background">
    <div class="header-container">
      <div class="nav-container">
        <div class="website-name-container">
          <img style="margin: 7px;" src="@/assets/logo-jobboardy.svg" @click="$router.push({ path: '/' })" />
          <div @click="$router.push({ path: '/' })" class="website-name">
            JobBoardy
          </div>
        </div>

        <ul class="nav-desktop-center">
          <li>
            <a @click="$router.push({ path: '/blog' })" class="menu-item">Blog</a>
          </li>
          <li>
            <a @click="$router.push({ path: '/how-it-works' })" class="menu-item">Features</a>
          </li>
          <li>
            <a @click="$router.push({ path: '/pricing' })" class="menu-item">Pricing</a>
          </li>
          <li>
            <a @click="$router.push({ path: '/sites' })" class="menu-item">Sites</a>
          </li>
          <li>
            <a @click="$router.push({ path: '/help' })" class="menu-item">Help</a>
          </li>
        </ul>

        <ul class="nav-desktop-right">
          <!-- Inactive when is logged -->
          <li v-if="!$store.state.auth.isLogged">
            <a @click="$router.push({ path: '/login' })" class="menu-item">Log in</a>
          </li>

          <!-- Active when is logged -->
          <li v-if="$store.state.auth.isLogged">
            <button
              @click="$router.push({ path: '/dashboard' })"
              class="secondary-button small-button"
              style="font-size: 0.8rem; margin-right: 0.3rem;"
              type="button"
            >
              Dashboard
            </button>
          </li>

          <!-- Active always -->
          <li>
            <button
              @click="$router.push({ path: '/suggest-site' })"
              class="tertiary-button small-button"
              style="font-size: 0.8rem; margin-right: 0.3rem;"
              type="button"
            >
              Suggest site
            </button>
          </li>
          <li>
            <button
              @click="$router.push({ path: '/post-job' })"
              class="primary-button small-button"
              style="font-size: 0.8rem;"
              type="button"
            >
              Post job
            </button>
          </li>
        </ul>

        <!-- Navigation links on mobile (hidden by default) -->
        <ul class="nav-mobile" v-if="isMobileMenuEnabled" id="mobile-menu-items">
          <li>
            <a
              @click="
                isMobileMenuEnabled = false;
                $router.push({ path: '/blog' });
              "
              class="menu-item-mobile"
              >Blog</a
            >
          </li>
          <li>
            <a
              @click="
                isMobileMenuEnabled = false;
                $router.push({ path: '/how-it-works' });
              "
              class="menu-item-mobile"
              >Features</a
            >
          </li>
          <li>
            <a
              @click="
                isMobileMenuEnabled = false;
                $router.push({ path: '/pricing' });
              "
              class="menu-item-mobile"
              >Pricing</a
            >
          </li>
          <li>
            <a
              @click="
                isMobileMenuEnabled = false;
                $router.push({ path: '/sites' });
              "
              class="menu-item-mobile"
              >Sites</a
            >
          </li>
          <li>
            <a
              @click="
                isMobileMenuEnabled = false;
                $router.push({ path: '/help' });
              "
              class="menu-item-mobile"
              >Help</a
            >
          </li>
          <li>
            <a
              @click="
                isMobileMenuEnabled = false;
                $router.push({ path: '/login' });
              "
              class="menu-item-mobile"
              >Log in</a
            >
          </li>
          <li>
            <button
              @click="
                isMobileMenuEnabled = false;
                $router.push({ path: '/suggest-site' });
              "
              class="tertiary-button small-button"
              style="font-size: 0.8rem; margin-bottom: 0.3rem;"
              type="button"
            >
              Suggest site
            </button>
          </li>
          <li>
            <button
              @click="
                isMobileMenuEnabled = false;
                $router.push({ path: '/post-job' });
              "
              class="primary-button small-button"
              style="font-size: 0.8rem;"
              type="button"
            >
              Post job
            </button>
          </li>
        </ul>

        <!-- Hamburger menu to toggle the navigation links -->
        <div @click="isMobileMenuEnabled = !isMobileMenuEnabled" class="mobile-menu-button">
          <i class="fas fa-bars mobile-menu-icon"></i>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      isMobileMenuEnabled: false,
    };
  },
};
</script>

<style scoped>
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
li {
  float: left;
}
.menu-item {
  display: block;
  color: var(--primary-text-color);
  text-align: center;
  padding: 0.5rem 1.1rem;
  text-decoration: none;
  font-weight: bold;
  font-size: 0.8rem;
  cursor: pointer;
}
.top-bar-background {
  background-color: var(--global-header-color);
  border-bottom: 1px solid var(--secondary-color);
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 5;
}
.header-container {
  max-width: 1500px;
  padding: 10px 3rem 10px 3rem;
  margin: 0 auto;
}
.nav-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.nav-desktop-right {
  display: flex;
  align-items: center;
}
.nav-mobile {
  display: none;
  position: fixed;
  top: 3rem;
  left: 0;
  right: 0;
  width: 100%;
  padding: 1rem;
  background-color: var(--global-header-color);
  border-bottom: 1px solid var(--secondary-color);
}
.menu-item-mobile {
  display: block;
  color: var(--primary-text-color);
  text-align: center;
  padding: 0.8rem;
  text-decoration: none;
  font-weight: bold;
  font-size: 12px;
}
.mobile-menu-button {
  display: none;
}
@media (max-width: 760px) {
  .header-container {
    padding: 0.5rem 0.5rem;
  }
  .website-name {
    font-size: 1.1rem;
  }
  .nav-mobile {
    display: flex;
    flex-direction: column;
  }
  .nav-desktop-center {
    display: none;
  }
  .nav-desktop-right {
    display: none;
  }
  .mobile-menu-icon {
    font-size: 18px;
    color: var(--primary-text-color);
    margin-right: 0.5rem;
  }
  .mobile-menu-button {
    display: flex;
  }
}
</style>
